// extracted by mini-css-extract-plugin
module.exports = {"common-link-error":"reportModal__common-link-error","toolbar":"reportModal__toolbar","links":"reportModal__links","table-container":"reportModal__table-container"};